<template>
    <div id="VehicleLeft" class="animate__animated" :class="this.$store.state.class_animate.class_animate_left">
        <div class="title">
            <div class="title-name">农机</div>
            <div class="title-back" @click="goBack()">
                <img src="../assets/indexImages/back.png" alt="">
            </div>
        </div>
        <div class="search">
            <div class="search-list">
                <el-select v-model="m_id" placeholder="请选类型" clearable>
                    <el-option v-for="item in moduleData" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="search-list">
                <div class="input">
                    <el-input size="small" v-model="cph" placeholder="请输入车牌号或主机id" clearable>
                    </el-input>
                </div>
            </div>
        </div>
        <div class="VehicleTree"  v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="transparent" >
            <!-- <h4>车辆管理</h4> -->
            <div class="tree-container">
                    <el-tree class="tree"
                             ref="tree"
                             :data="treeData"
                             @close="handleClose"
                             :props="defaultProps"
                             :default-expand-all="isExpand"
                             accordion @node-click="nodeclick"
                             @check="handleCheckChange"
                             node-key="vehicleId"
                             :default-expanded-keys="treeExpandData"
                             :default-checked-keys="treeCheckedData"
                             current-node-key="currentNodeKey"
                             :filter-node-method="filterNode"
                             :highlight-current="isHighLight"
                             :render-content="renderContent">
                </el-tree>
            </div>
        </div>
    </div>
</template>
<script>
import {index} from '../js/index.js'
import eventBus from "../eventBus";
import {mapclear} from "../js/mapclear";
import ModuleService from "../jaxrs/concrete/com.zny.eop.socialService.api.ModuleService";
export default {
    data(){
        return{
            userType:localStorage.getItem('userType'),
            m_id:"",
            cph:'',
            vehicleType:'',
            moduleData:[],
            options: [
                {value:'拖拉机',id:1},
                {value:'收获机',id:2},
                {value:'飞防',id:3},
                {value:'自走式植保机',id:4},
                {value:'其他',id:5},
            ],
            onlineOptions:[
                {value:'在线',id:1},
                {value:'报警',id:2},
                {value:'离线',id:3},
            ],
            onlineType:'',
            VehicleId:"",
            filterText: '',
            treeData: [],
            provincialCenterId:"",
            treeExpandData:[],
            treeCheckedData:[],
            currentNodeKey:'',
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            timer:'',
            userId:'',
            vehicleId:'',
            VehicleName:'',
            search1:false,
            search2:false,
            isExpand:false,
            isHighLight:false,//树形结构中是否高亮显示当前节点
            loading:false,//加载中
        }
    },
    mounted(){
    },
    watch: {
        cph(val) {
            this.$refs.tree.filter(val);
        },
        m_id(val){
            this.$refs.tree.filter(val);
        }
    },
    created() {
        this.onload();
        this.getModuleList()
    },
    methods:{
        handleClose(key, keyPath) {
            this.$refs.tree.open(keyPath);
        },
        onload(){
            var that = this
            that.$store.state.class_animate.class_animate_left="animate__fadeInLeft"
            that.$store.state.rightChange=false
            that.treeData=that.$store.state.treeData
            that.loading=false
            //地块详情返回
            eventBus.$on('plotsBack',function () {
                //地块详情返回的时候vehicleId置空
                that.vehicleId=''
            })
            //服务组织查询车辆
            eventBus.$on('userVehicle',function (userId) {
                that.userId=userId
                that.$store.state.userId=userId
                mapclear.markersClear(that)
                index.getVehicleTree(that,userId)
            })
            //模拟量返回
            eventBus.$on('goBackVehicleLeft',function () {
                if(that.$store.state.userId!=""){
                     mapclear.markersClear(that)
                    index.getVehicleTree(that,that.$store.state.userId)
                }
            })
            //地图点击车辆的时候
            eventBus.$on('mapCheckVehicle',function (id) {
                that.vehicleId=id
                that.$store.state.vehicleTreeNodeChecked=id
                //显示上次选中的节点
                that.currentNodeKey=that.$store.state.vehicleTreeNodeChecked
                that.$nextTick(function () {
                    that.isHighLight=true
                    that.$refs.tree.setCurrentKey(that.currentNodeKey)
                })
                that.$nextTick(function () {
                    setTimeout(function () {
                        eventBus.$emit('mapClick',id)
                    },500)
                })
            })
            //显示上次选中的节点
            that.currentNodeKey=that.$store.state.vehicleTreeNodeChecked
            that.vehicleId=that.$store.state.vehicleTreeNodeChecked
            that.treeCheckedData.push(that.$store.state.vehicleTreeNodeChecked)
            that.treeExpandData.push(that.$store.state.vehicleTreeNodeChecked)
            that.$nextTick(function () {
                that.isHighLight=true
                that.$refs.tree.setCurrentKey(that.currentNodeKey)
            })
        },
        //内容显示不同样式
        renderContent(h, { node, data, store }) {
            // console.log(data)
            var font = this.fontBuild(node,data)
            return(
                <span class={font} style="cursor:pointer">
                {node.label}
                </span>
        )
        },
        //获取作业类型
        getModuleList(){
            var that = this
            ModuleService.findAllModule()
                .then(response=>{
                    that.moduleData=response
                })
                .catch(error=>{
                    console.log(error)
                })
        },
        //车辆树层级显示不同样式
        fontBuild(node,data){
            // console.log(data)
            for(var i=1;i<=5;i++){
                if(node.level==i){
                    if(data.online){
                        if(data.isAlarm||data.onlineType==2){
                            return 'font'+i+' isAlarm'
                        }else{
                            if(data.plateNo){
                                return 'font'+i+' isOnline'
                            }else{
                                return 'font'+i+' common-category'
                            }
                        }
                    }else{
                        if(data.onlineType==2){
                            return 'font'+i+' isAlarm'
                        }else{
                            return 'font'+i+' common-category'
                        }
                    }
                }
            }
        },
        // 返回首页
        goBack(){
            var that=this
            that.$store.state.class_animate.class_animate_left="animate__fadeOutLeft"
            that.$store.state.class_animate.class_animate_right="animate__fadeOutRight"
            mapclear.markersClear(that)
            mapclear.linesClear(that)
            mapclear.photosClear(that)
            mapclear.clearMeadures(that)
            if(that.$store.state.userId!=""){
                that.treeData=[]
                that.$store.state.lastChange=0
                that.$store.state.vehicleChange=0
                that.$store.state.change=10
                that.$nextTick(function () {
                    setTimeout(function () {
                        eventBus.$emit("toOrganization",'')
                    },500)
                })
            }else{
                that.$store.state.lastChange=0
                that.$store.state.vehicleChange=0
                that.$store.state.change=1
            }
            //清空userId
            that.$store.state.userId=''
            //清空选中的节点
            that.$store.state.vehicleTreeNodeChecked=''
        },
        filterNode(value, data) {
            if(data.vehicleId){
                if(data.simNo&&data.simNo!=''&&data.simNo!=null&&data.simNo!=undefined){
                    if(!this.cph&&!this.m_id){
                        return true;
                    }else if(!this.cph&&this.m_id){
                        return data.module==this.m_id;
                    }else if(this.cph&&!this.m_id){
                        return data.simNo.indexOf(this.cph) !== -1 || data.name.indexOf(this.cph) !== -1
                    }else if(this.cph&&this.m_id){
                        return (data.simNo.indexOf(this.cph) !== -1 || data.name.indexOf(this.cph) !== -1) && data.module==this.m_id;
                    }
                }else{
                    if(!this.cph){
                        return true;
                    }else if(this.cph){
                        return data.name.indexOf(this.cph) !== -1
                    }
                }
            }
        },
        // 获取树形结构默认展开节点/选中节点
        getRoleTreeRootNode(provincialCenterId) {
            this.treeExpandData.push(provincialCenterId)   
            this.treeCheckedData.push(provincialCenterId)
        },
        // 树形控件复选框选中事件
        handleCheckChange(data, checked){
            if(!data.children){
            }
        },
        // 树形控件节点选中事件
        nodeclick(data,checked,node){
            var that=this
            that.$store.state.vehicleTreeNodeChecked=data.vehicleId
            if(checked.isLeaf){//叶子节点显示高亮
                that.isHighLight=true
            }else{
                that.isHighLight=false
            }
            if(data.vehicleId==that.vehicleId||data.vehicleId==undefined){
                return
            }else{
                //选中后显示车辆信息
                that.vehicleId=data.vehicleId
                that.$store.state.vehicleId=data.vehicleId
                that.vehicleHandle(data.vehicleId)
            }
        },
        vehicleHandle(vehicleId){
            var that = this
            that.$store.state.rightChange=true
            that.$store.state.vehicleChange=that.$store.state.change
            that.$store.state.lastChange=0
            that.$nextTick(function () {
                setTimeout(function(){
                    eventBus.$emit('treeCheckVehicle',vehicleId)
                },500)
            })
        },
    },
    beforeDestroy() {
        var that = this
        that.$store.state.rightChange=true
        eventBus.$off('plotsBack')
        eventBus.$off('plotDetails')
        eventBus.$off('trackPlayBack')
        eventBus.$off('userVehicle')
        eventBus.$off('mapCheckVehicle')
        //重置data数据
        Object.assign(that.$data,that.$options.data())
    },
}
</script>
<style lang="less" >
@import '../componentsStyle/VehicleLeft.less'; 
</style>